(function () {
    // Apple service wrapper
    SUGApp.service('appleService', ['$q', '$window', 'SUGUtilities', function ($q, $win, util) {
        var service = {
            appleLoading: false
        };

        var setAppleLoading = function (processing) {
            service.appleLoading = processing ? true : false;
        };

        setAppleLoading(true);

        // Apple pre-login to get the auth URL and open the popup
        var applePreLogin = function() {
            return new Promise(function(resolve, reject) {
                util.APISyncCallV3(
                    'get',
                    'auth/applePreLogin',
                    {},
                    15000
                ).then(function(response) {
                    let res = util.lowerCaseKeys(response);
                    if (res?.data?.response?.appleurl) {
                        resolve(res.data.response.appleurl);
                    }
                }).catch(function(error) {
                    return reject(new Error(`Apple login failed: ${JSON.stringify(error)}`));
                });
            });
        }

        var applePostLogin = function(payload) {
            return new Promise(function(resolve, reject) {
                util.APISyncCallV3(
                    'post',
                    'auth/identityproviderlogin',
                    { identityProviderToken: payload, identityProviderType: 'apple' },
                    15000
                ).then(function(apiResponse) {
                    // Handle backend response (user info, JWT, etc.)
                    var result = util.parseSocialLoginResult(apiResponse);
                    if (result && result.token) {
                        resolve(result.token);
                    } else if (result && result.blocked) {
                        // Disabled/blocked account — no token was issued. Signal the caller.
                        reject(result.blocked);
                    } else {
                        reject(new Error('Apple login failed'));
                    }
                }).catch(function(error) {
                    // A blocked login returns HTTP 4xx, so $http rejects into here; error.data is the body.
                    var result = util.parseSocialLoginResult(error);
                    if (result && result.blocked) {
                        reject(result.blocked);
                    } else {
                        reject(new Error(`Apple login failed: ${JSON.stringify(error)}`));
                    }
                });
            });
        }

        service.loginWithApple = function() {
            return new Promise(function(resolve, reject) {
                // Start the login process
                applePreLogin()
                .then(function(authUrl) {
                    // Open the popup and wait for result
                    return openOAuthPopup(authUrl);
                })
                .then(function(result) {
                    return applePostLogin(result);
                })
                .then(function(token){
                    if(token) {
                        resolve(token);
                    } else {
                        reject('failed')
                    }
                })
                .catch(function(err) {
                    reject(err);
                });
            });
        }

        var openOAuthPopup = function(authUrl) {
            return new Promise((resolve, reject) => {
                // Open the popup
                const width = 500;
                const height = 700;
                const left = window.screenX + (window.outerWidth - width) / 2;
                const top = window.screenY + (window.outerHeight - height) / 2;

                localStorage.removeItem("appleAuthResult");

                const popup = window.open(
                    authUrl,
                    'applePopup',
                    `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`
                );

                if (!popup) {
                    return reject(new Error('To continue, you may need to enable pop-up windows in your browser for this site.'));
                }

                const timer = setInterval(() => {
                    if (popup.closed) {
                        clearInterval(timer);
                        // Check if Apple result exists
                        setTimeout(function() {
                            const result = localStorage.getItem("appleAuthResult");
                            if (result) {
                                localStorage.removeItem("appleAuthResult"); // cleanup
                                resolve(result);
                            } else {
                                // This is a solution to race condition between closing popup and setting localStorage
                                // added more delay to grab item from storage and then process
                                setTimeout(function(){
                                    const retryResult = localStorage.getItem("appleAuthResult");
                                    if (retryResult) {
                                        localStorage.removeItem("appleAuthResult"); // cleanup
                                        resolve(retryResult);
                                    } else {
                                        reject(new Error('Popup closed without login result'));
                                    }
                                }, 1000);
                            }
                        }, 300);
                    }
                }, 500);
            });
        }

        // Return service object
        return service;
    }]);
})();